import { render, staticRenderFns } from "./lsfz.vue?vue&type=template&id=6dc8b8a2&scoped=true"
import script from "./lsfz.vue?vue&type=script&lang=js"
export * from "./lsfz.vue?vue&type=script&lang=js"
import style0 from "./lsfz.vue?vue&type=style&index=0&id=6dc8b8a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc8b8a2",
  null
  
)

export default component.exports